import React, { PureComponent, Fragment } from 'react'
import moment from 'moment'
import cx from 'classnames'

import { Grid, Cell } from 'components/layout/grid'
import Button from 'components/ui/Button/Button'
import Box from 'components/layout/Box/Box'


class TrainerModal extends PureComponent {

  state = {
    node: null,
  }

  componentDidMount() {
    const encodedUri  = this.getEncodeUri()
    const link        = document.createElement('a')

    link.setAttribute('href', encodedUri)
    link.setAttribute('download', `${this.getTitle()}.csv`)

    document.body.appendChild(link)

    this.setState({ node: link })
  }

  componentWillUnmount() {
    const { node } = this.state

    document.body.removeChild(node)
  }

  getTitle = () => {
    const { from, to, trainer } = this.props

    const date = `с ${moment(from, 'DDMMYYYY').format('DD.MM.YYYY')} по ${moment(to, 'DDMMYYYY').format('DD.MM.YYYY')}`

    return `Отчет: Тренер ${trainer || ''} ${date}`
  }

  getEncodeUri = () => {
    const { statistic } = this.props

    let encodeData = 'data:text/csv;charset=utf-8,\uFEFF'

    const rows = []

    rows.push([ this.getTitle() ])
    rows.push([ 'Дата', 'Количество занятий', ])

    Object.keys(statistic).forEach((key, index) => {
      const count = statistic[key]

      rows.push([ moment(key, 'YYYY-MM-DD').format('DD.MM.YYYY'), count ])
    })

    return `${encodeData}${
      rows.map((items) => (
        items.map((item) => String(item || '')).join(';')
      ))
        .join('\n')
      }`
  }

  handleButtonClick = () => {
    const { node } = this.state
    const { onClose } = this.props

    node.click()
    onClose()
  }

  render() {
    const {
      titleClassName, darkClassName, buttonClassName,
      statistic, isEmpty,
    } = this.props

    return (
      <Fragment>
        <Box pb="md">
          <div className={titleClassName}>{this.getTitle()}</div>
        </Box>
        {
          isEmpty ? (
            <div>Нет статистики по выбранным условиям</div>
          ) : (
            <Fragment>
              {
                Object.keys(statistic).map((key, index) => {
                  const count = statistic[key]

                  return (
                    <Fragment key={key}>
                      {
                        Boolean(!index) && (
                          <Grid className={darkClassName} columns={2} gutter="md">
                            <Cell size={1}>
                              Дата
                            </Cell>
                            <Cell size={1}>
                              Количество занятий
                            </Cell>
                          </Grid>
                        )
                      }

                      <Grid className={cx({ [darkClassName]: index % 2 !== 0 })} columns={2} gutter="md">
                        <Cell size={1}>
                          {moment(key, 'YYYY-MM-DD').format('DD.MM.YYYY')}
                        </Cell>
                        <Cell size={1}>
                          {count}
                        </Cell>
                      </Grid>
                    </Fragment>
                  )
                })
              }
              <Box pt="md">
                <Button
                  className={buttonClassName}
                  title="Сохранить в файл"
                  green
                  onClick={this.handleButtonClick}
                />
              </Box>
            </Fragment>
          )
        }
      </Fragment>
    )
  }
}


export default TrainerModal
